import React from 'react';
import { PiWarningCircleFill } from 'react-icons/pi';
import { Alert } from 'src/modules/shared/components/atoms/alert';
import { Text } from 'src/modules/shared/components/atoms/text';
import { useI18n } from 'src/modules/shared/hooks/provider-bounded/i18n';
import type { PropertyPublicationAlert } from '../../utils/property-publication-alert.util';

interface PropertyPublicationAlertsProps {
  alerts: PropertyPublicationAlert[];
  extraMessages?: string[];
}

export const PropertyPublicationAlerts: React.FC<
  PropertyPublicationAlertsProps
> = ({ alerts, extraMessages = [] }) => {
  const { t } = useI18n();

  if (alerts.length === 0 && extraMessages.length === 0) {
    return null;
  }

  const fallbackAlert: PropertyPublicationAlert = {
    code: 'additional_issues',
    severity: 'warning',
    titleKey: 'catalog.properties.meli.currentPublication.history.error',
    descriptionKey: 'catalog.properties.meli.currentPublication.history.empty',
    summaryKey: 'catalog.properties.meli.currentPublication.history.error',
  };
  const alertsToRender = alerts.length > 0 ? alerts : [fallbackAlert];

  return (
    <div className="space-y-2">
      {alertsToRender.map((alert, index) => (
        <Alert
          key={alert.code}
          variant={alert.severity === 'danger' ? 'danger' : 'warning'}
          appearance="soft"
          icon={
            <span className="mt-0.5 inline-flex self-start">
              <PiWarningCircleFill className="h-4 w-4" />
            </span>
          }
          message={
            <div className="flex flex-col gap-0.5">
              <Text size="small" weight="medium" className="text-slate-900">
                {t(alert.titleKey)}
              </Text>
              {alerts.length > 0 ? (
                <Text size="tiny" className="text-slate-600">
                  {t(alert.descriptionKey)}
                </Text>
              ) : null}
              {index === 0 && extraMessages.length > 0 ? (
                <ul className="mt-2 list-disc space-y-1 pl-4 text-xs text-slate-600">
                  {extraMessages.map((message) => (
                    <li key={`${alert.code}-${message}`}>{message}</li>
                  ))}
                </ul>
              ) : null}
            </div>
          }
        />
      ))}
    </div>
  );
};
